import { EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonService } from "../common.service";
var ActivityFormComponent = (function () {
    function ActivityFormComponent(apiService, route, router, commonService) {
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.commonService = commonService;
        this._signInNumber = false;
        this._signInPhone = true;
        this.submitButtonDisabledNum = true;
        this.submitButtonDisabledPhone = true;
        this.onSuccess = new EventEmitter();
    }
    ActivityFormComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getStatus();
        this.status = this.route.params.subscribe(function (params) {
            _this.formId = params['formId'];
            _this.registerCode = params['codeId'];
            if (_this.formId == 299 || _this.formId == 399 || _this.formId == 398 || _this.formId >= 600) {
                _this.formIdTag = true;
            }
            else {
                _this.formIdTag = false;
            }
        });
        if (this.formId == 3 || this.formId == 398) {
            this.shenqing = true;
            this.land = false;
        }
        if (this.formId == 1 || this.formId == 299 || this.formId == 399 || this.formId >= 600) {
            this.land = true;
            this.shenqing = false;
        }
        this.registerType = 2;
        this.canSendCode = true;
        this.submitButtonDisabled = false;
        this.personalUserSelected = false;
        this.scaleOptions = [
            "1-50人",
            "51-300人",
            "301-1000人",
            "1000人以上"
        ];
        this.postOptions = [
            "公司高层",
            "HR部门",
            "中基层企业管理者",
            "其他"
        ];
        this.options = this.scaleOptions;
        this.isKeybordShow = false;
        var that = this;
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isAndroid) {
            $(window).resize(function () {
                var newHeight = $(window).height();
                if (that.oriHeight - newHeight > 100) {
                    that.isKeybordShow = true;
                }
                else if (that.oriHeight == newHeight) {
                    that.isKeybordShow = false;
                }
            });
        }
        // if(isIOS){
        //   $(window).resize(function () {
        //     let newHeight = $(window).height();
        //     if (that.oriHeight-newHeight>100){
        //       that.isKeybordShow = true;
        //     } else if (that.oriHeight==newHeight){
        //       that.isKeybordShow = false;
        //     }
        //   });
        // }
        this.showButton = false;
        var href = window.location.href;
        var str = href.split('/form/')[1];
        if (str != '3#wechat_login' && str != '3') {
            window.sessionStorage.setItem('specialUser', 'specialUser');
        }
        else {
            window.sessionStorage.removeItem('specialUser');
        }
    };
    ActivityFormComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
        var choiceBox = document.getElementById("choice");
        var choiceBoxHeight = choiceBox.offsetHeight;
        var bodyHeight = document.body.offsetHeight;
        choiceBox.style.top = bodyHeight + 'px';
        choiceBox.style.maxHeight = document.body.offsetHeight * 0.99 + 'px';
        this.oriHeight = $(window).height();
    };
    ActivityFormComponent.prototype.getStatus = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/getUserInfo',
            'data': {}
        }).subscribe(function (status) {
            _this.status = status;
            if (_this.status != 3) {
                _this.yishengqing = true;
                _this.tijiao = false;
            }
            else {
                _this.yishengqing = false;
                _this.tijiao = true;
            }
        });
    };
    ActivityFormComponent.prototype.shiyong = function () {
        $("#mengban").fadeOut();
        $("#tab_3").fadeOut();
        this.shenqing = true;
    };
    ActivityFormComponent.prototype.closeTip = function () {
        $("#mengban").fadeOut();
    };
    ActivityFormComponent.prototype.close = function () {
        var newEdition = window.sessionStorage.getItem('newEdition');
        if (newEdition) {
            var link = ['activity'];
            this.router.navigate(link);
        }
        else {
            var link = ['learning-map'];
            this.router.navigate(link);
        }
    };
    ActivityFormComponent.prototype.tabTitleClicked = function (bool) {
        this.personalUserSelected = bool;
        this.registerType = bool ? 1 : 2;
        if (!this.canSendCode) {
            $("#tab_1_verification_send_out").css({ "color": "#ffe258" });
            $("#tab_2_verification_send_out").css({ "color": "#ffe258" });
        }
    };
    ActivityFormComponent.prototype.onScaleClicked = function () {
        $('.companySizeValidateTxt').removeClass('showValidateTxt');
        if (!this.isKeybordShow) {
            this.options = this.scaleOptions;
            this.isScaleClicked = true;
            this.display();
        }
    };
    ActivityFormComponent.prototype.onPostClicked = function () {
        $('.companyJobValidateTxt').removeClass('showValidateTxt');
        if (!this.isKeybordShow) {
            this.options = this.postOptions;
            this.isScaleClicked = false;
            this.display();
        }
    };
    ActivityFormComponent.prototype.onChoiceClick = function (option) {
        this.hide();
        if (this.isScaleClicked) {
            $("#tab_2_scale_input").val(option);
            this.size = option;
        }
        else {
            $("#tab_2_post_input").val(option);
            this.title = option;
        }
    };
    ActivityFormComponent.prototype.onShadeClick = function () {
        this.hide();
    };
    ActivityFormComponent.prototype.onFocus = function (id) {
        var _this = this;
        var target = $("#" + id).data('target');
        console.log(target);
        $('.' + target + 'ValidateTxt').removeClass('showValidateTxt');
        $("#" + id).bind('input porpertychange', function () {
            if (_this.checkMobile($("#" + id).val())) {
                if (_this.personalUserSelected) {
                    $("#tab_1_verification_send_out").css({ "color": "#fff" });
                }
                else {
                    $("#tab_2_verification_send_out").css({ "color": "#fff" });
                }
            }
            else {
                if (_this.canSendCode) {
                    if (_this.personalUserSelected) {
                        $("#tab_1_verification_send_out").css({ "color": "#a4a9c0" });
                    }
                    else {
                        $("#tab_2_verification_send_out").css({ "color": "#a4a9c0" });
                    }
                }
            }
        });
    };
    ActivityFormComponent.prototype.onBlur = function () {
        console.log("#tab_2_company_input ---- blur");
    };
    ActivityFormComponent.prototype.display = function () {
        var choiceBox = document.getElementById("choice");
        choiceBox.style.display = "block";
        var choiceBoxHeight = choiceBox.offsetHeight;
        var bodyHeight = document.body.offsetHeight;
        choiceBox.style.top = bodyHeight - choiceBoxHeight + 'px';
        $("#shade").fadeIn(500);
        /*this.scrollTop = document.body.scrollTop | document.documentElement.scrollTop;
        $("#wrap").addClass("fixed");
        $("#wrap").css({top:-this.scrollTop});*/
        document.getElementById('shade').ontouchmove = function (e) { e.preventDefault(); };
        document.getElementById('choice').ontouchmove = function (e) { e.preventDefault(); };
    };
    ActivityFormComponent.prototype.hide = function () {
        var choiceBox = document.getElementById("choice");
        var bodyHeight = document.body.offsetHeight;
        choiceBox.style.top = bodyHeight + 'px';
        setTimeout(function () {
            choiceBox.style.display = "none";
        }, 500);
        $("#shade").fadeOut(500);
        /*$("#wrap").removeClass("fixed");
        document.documentElement.scrollTop = this.scrollTop;*/
    };
    ActivityFormComponent.prototype.checkMobile = function (mobile) {
        if ((!(/^1[3|4|5|6|7|8|9]\d{9}$/.test(mobile))) && ((mobile.indexOf("886") != 0) && (mobile.indexOf("852") != 0))) {
            return false;
        }
        return true;
    };
    ActivityFormComponent.prototype.tip = function (tipWord) {
        /*document.getElementById("tip").style.display="none";*/
        $("#tip").text(tipWord);
        $("#tip").fadeIn(2000, function () {
            $("#tip").fadeOut(2000);
        });
    };
    ActivityFormComponent.prototype.sendCode = function (isPersonal) {
        var _this = this;
        if (isPersonal && this.canSendCode) {
            this.phone = this.phone_1;
        }
        else if (!isPersonal && this.canSendCode) {
            this.phone = this.phone_2;
        }
        if (!this.canSendCode) {
            // this.tip("请等待倒计时结束再发送");
            $('.smsCodeValidateTxt').text('请等待倒计时结束再发送');
            $('.smsCodeValidateTxt').addClass('showValidateTxt');
            return;
        }
        if (this.phone == "" || typeof (this.phone) == 'undefined') {
            // this.tip("请填写手机号");
            $('.phoneValidateTxt').text('请填写手机号');
            $('.phoneValidateTxt').addClass('showValidateTxt');
            return;
        }
        if (!this.checkMobile(this.phone)) {
            $('.phoneValidateTxt').text('请填写正确手机号');
            $('.phoneValidateTxt').addClass('showValidateTxt');
            // this.tip("请填写正确手机号");
            return;
        }
        this.canSendCode = false;
        var remainTime = 60;
        var that = this;
        var timeInterval = setInterval(function () {
            if (isPersonal) {
                $("#tab_1_verification_send_out").css({ "color": "#ffe258" });
                $("#tab_1_verification_send_out_word").text("重新获取");
                $("#tab_1_verification_send_out_remain_time").text("(" + remainTime + "s)");
            }
            else {
                $("#tab_2_verification_send_out").css({ "color": "#ffe258" });
                $("#tab_2_verification_send_out_word").text("重新获取");
                $("#tab_2_verification_send_out_remain_time").text("(" + remainTime + "s)");
            }
            /*$(".send_out_word").text("重新获取");
            $(".remainTime").each(function( index ) {
                $(this).text("(" + remainTime + "s)");
            });*/
            remainTime = remainTime - 1;
            if (remainTime == -1) {
                $(".remainTime").each(function (index) {
                    $(this).text("");
                });
                clearInterval(timeInterval);
                that.canSendCode = true;
                $(".send_out").css({ "color": "#a4a9c0" });
                $(".send_out_word").text("发送验证码");
            }
        }, 1000);
        var data = {
            "phone": this.phone
        };
        this.apiService.sendCode(data).subscribe(function (result) {
            if (result.Code != "OK") {
                if (result.Code = "isv.BUSINESS_LIMIT_CONTROL") {
                    _this.tip("操作频繁，请稍后尝试");
                }
                else {
                    //this.tip(result.Message);
                    _this.tip("有错误，请重新操作");
                }
            }
        });
    };
    ///* 企业员工可以通过员工号密码登录学习  2019-9-4 start*/
    // $("input").blur(function () {
    //    $("#tab_4").animate({scrollTop: document.documentElement.clientHeight},500);
    // });
    ActivityFormComponent.prototype.click_blur = function () {
        // $("#tab_4").animate({scrollTop: document.documentElement.clientHeight},500);
        window.scroll(0, 0);
        this.commonService.initPage();
        console.log(11);
    };
    ActivityFormComponent.prototype.signInPhone = function () {
        // $('.signInPhone').css('display','none');
        // $('.signInNumber').css('display','block');
        this._signInNumber = true;
        this._signInPhone = false;
        $('#tab_1_Phone_input').val("");
        $('#tab_1_verification_input').val("");
        this.phone_1 = "";
        this.verification_code_1 = "";
        // this.Number = '';
        // this.verification_pwd='';
        //    this.phone = '';
        // this.verification_code='';
    };
    ActivityFormComponent.prototype.signInNumber = function () {
        // $('.signInPhone').css('display','block');
        // $('.signInNumber').css('display','none');
        this._signInNumber = false;
        this._signInPhone = true;
        $('#tab_1_Number_input').val("");
        $('#tab_1_Pwd_input').val("");
        this.Number_1 = '';
        this.verification_Pwd_1 = '';
        //    this.phone = '';
        // this.verification_code='';
    };
    ActivityFormComponent.prototype.toset = function (msg) {
        $("#toset_div").empty();
        $("#toset_div").css("display", "block");
        $("#toset_div").append(msg);
        setTimeout("$('#toset_div').hide()", 1500);
    };
    ActivityFormComponent.prototype.loginPhone = function () {
        var _this = this;
        this.phone = this.phone_1;
        this.verification_code = this.verification_code_1;
        if (this.phone == "" || typeof (this.phone) == 'undefined') {
            // this.tip("请填写手机号");
            // $('.phoneValidateTxt').text('请填写手机号码');
            // $('.phoneValidateTxt').addClass('showTxt');
            this.toset("请填写手机号");
            return false;
        }
        if (!this.checkMobile(this.phone)) {
            // $('.phoneValidateTxt').text('请填写正确手机号');
            // $('.phoneValidateTxt').addClass('showTxt');
            this.toset("该手机号码暂不支持");
            return false;
        }
        this.submitButtonDisabled = true;
        if (!this.phone) {
            this.toset("请填写手机号码");
            // $('.phoneValidateTxt').text('请填写手机号码');
            // $('.phoneValidateTxt').addClass('showTxt');
            this.submitButtonDisabled = false;
            return false;
        }
        else if (!this.verification_code) {
            this.toset("请填写手机验证码");
            // $('.smsCodeValidateTxt').text('请填写手机验证码');
            // $('.smsCodeValidateTxt').addClass('showTxt');
            this.submitButtonDisabled = false;
            return false;
        }
        var dataphone = {
            "phone": this.phone,
            "verificationCode": this.verification_code,
        };
        this.apiService.ajax({
            'type': 'post',
            'url': 'sr/userlogin/validateLogonPhone',
            'data': dataphone,
        }).subscribe(function (result) {
            if (result.success) {
                _this.loginPhp();
                // }else if(result.data==2){//弹出提示框
                // 	$(".model_div").css('display','block');
                // 	$(".phoneClass").css('display','block');
                // }else{
                // 	this.tip("返回错误！");
                // }
            }
            else {
                if (result.code == 1000) {
                    _this.toset("用户userId不存在");
                    return;
                }
                else if (result.code == 1003) {
                    $(".model_div").css('display', 'block');
                    $(".phoneClass").css('display', 'block');
                }
                else if (result.code == 2001) {
                    _this.toset("该手机号在系统中不存在");
                    return;
                }
                else if (result.code == 2002) {
                    _this.toset("手机号或验证码不正确");
                    return;
                }
            }
        });
    };
    ActivityFormComponent.prototype.loginPhp = function () {
        var _this = this;
        var data = {
            "registerType": 1,
            "phone": this.phone,
            "verification_code": this.verification_code,
        };
        this.apiService.registerUser(data).subscribe(function (result) {
            console.log(result);
            if (result.code == "Success") {
                console.log("登陆成功");
                var dataphone = {
                    "phone": _this.phone,
                };
                _this.apiService.ajax({
                    'type': 'post',
                    'url': 'sr/userlogin/authenticationPhone',
                    'data': dataphone,
                }).subscribe(function (result) {
                    console.log(result);
                    if (result.success == true) {
                        console.log("登陆成功");
                        if (_this.formId >= 600) {
                            var link = ['learning-map', _this.formId];
                            _this.router.navigate(link);
                        }
                        else {
                            var link = ['learning-map'];
                            _this.router.navigate(link);
                        }
                    }
                    else {
                        // $('.smsCodeValidateTxt').text('手机号或验证码不正确');
                        // $('.smsCodeValidateTxt').addClass('showTxt');
                        _this.submitButtonDisabled = false;
                        _this.toset("手机号或验证码不正确");
                        return;
                    }
                });
            }
            if (result.code == "Not_Lookup_Company") {
                console.log("您还没有绑定任何账户");
                _this.toset("您还没有绑定任何账户");
                $("#mengban").fadeIn();
            }
            else if (result.code == "Not_Matched") {
                // this.tip("手机号或验证码不正确");
                // $('.smsCodeValidateTxt').text('手机号或验证码不正确');
                // $('.smsCodeValidateTxt').addClass('showTxt');
                _this.toset("手机号或验证码不正确");
                _this.submitButtonDisabled = false;
                return;
            }
            else if (result.code == "Duplicate_Company") {
                // this.tip(this.name + "已经被注册");
                // $('.smsCodeValidateTxt').text(this.name + "已经被注册");
                // $('.smsCodeValidateTxt').addClass('showTxt');
                _this.toset(_this.name + "已经被注册");
                _this.submitButtonDisabled = false;
                return;
            }
            else if (result.code == "Phone_Not_Matched") {
                // this.tip("手机号和接受验证码手机号不一致，请重新发送验证码");
                // $('.smsCodeValidateTxt').text('手机号或验证码不正确');
                // $('.smsCodeValidateTxt').addClass('showTxt');
                _this.toset("手机号和接受验证码手机号不一致，请重新发送验证码");
                _this.submitButtonDisabled = false;
                return;
            }
        });
    };
    ActivityFormComponent.prototype.loginAgainPhone = function () {
        $(".model_div").css('display', 'none');
        $(".phoneClass").css('display', 'none');
        this.loginPhp();
    };
    ActivityFormComponent.prototype.loginPwd = function () {
        var _this = this;
        this.Number = this.Number_1;
        this.verification_pwd = this.verification_Pwd_1;
        if (this.Number == "" || typeof (this.Number) == 'undefined') {
            // this.tip("请填写账号");
            // $('.NumberValidateTxt').text('请填写账号');
            // $('.NumberValidateTxt').addClass('showTxt');
            this.toset("请填写账号");
            return false;
        }
        if (this.verification_pwd == "" || typeof (this.verification_pwd) == 'undefined') {
            // this.tip("请填写账号密码");
            // $('.PwdTxt').text('请填写账号密码');
            // $('.PwdTxt').addClass('showTxt');
            this.toset("请填写账号密码");
            return false;
        }
        var data = {
            "userName": this.Number,
            "password": this.verification_pwd,
        };
        this.apiService.ajax({
            'type': 'post',
            'url': 'sr/userlogin/validateLogon',
            'data': data,
        }).subscribe(function (result) {
            if (result.success) {
                _this.apiService.ajax({
                    'type': 'post',
                    'url': 'sr/userlogin/authentication',
                    'data': data,
                }).subscribe(function (result2) {
                    if (result2.success) {
                        if (_this.formId >= 600) {
                            var link = ['learning-map', _this.formId];
                            _this.router.navigate(link);
                        }
                        else {
                            var link = ['learning-map'];
                            _this.router.navigate(link);
                        }
                    }
                });
            }
            else {
                // if(result.data==2){
                //   $(".model_div").css('display','block');
                //   $(".numberClass").css('display','block');
                // }else{
                //   // this.tip("账号密码不正确");
                //   // $(".signInform .input_text").css('border','1px solid #f96678');
                //   $('.PwdTxt').text('账号密码不正确');
                //   $('.PwdTxt').addClass('showTxt');
                //   this.submitButtonDisabled = false;
                //   return;
                // }
                if (result.code == 1000) {
                    _this.toset("用户userId不存在");
                    return;
                }
                else if (result.code == 1001) {
                    _this.toset("该账号在系统中不存在");
                    return;
                }
                else if (result.code == 1002) {
                    _this.toset("账号或密码不正确");
                    return;
                }
                else if (result.code == 1003) {
                    $(".model_div").css('display', 'block');
                    $(".numberClass").css('display', 'block');
                }
            }
        });
        //  this.apiService.ajax({
        //   'type': 'post',
        //   'url': 'sr/userlogin/authentication',
        //   'data': data,
        // }).subscribe(result => {
        //   console.log(result);
        //   if (result.success == true) {//登录成功
        //      console.log("登陆成功");
        //      let link = ['learning-map'];
        //      this.router.navigate(link);
        //   }else{//登录失败
        // 	  if(result.data==2){
        // 		  console.log("您已在其他设备上登录，登录失败！");
        // 		  $(".model_div").css('display','block');
        // 		  $(".model_div_con").css('display','block');
        // 	  }else{
        // 		  // this.tip("账号密码不正确");
        // 		  // $(".signInform .input_text").css('border','1px solid #f96678');
        // 		  $('.PwdTxt').text('账号密码不正确');
        // 		  $('.PwdTxt').addClass('showTxt');
        // 		  this.submitButtonDisabled = false;
        // 		  return;
        // 	  }
        //
        //   }
        //
        // });
    };
    ActivityFormComponent.prototype.loginAgain = function () {
        var _this = this;
        $(".model_div").css('display', 'none');
        $(".numberClass").css('display', 'none');
        this.Number = this.Number_1;
        this.verification_pwd = this.verification_Pwd_1;
        var data = {
            "userName": this.Number,
            "password": this.verification_pwd,
        };
        this.apiService.ajax({
            'type': 'post',
            'url': 'sr/userlogin/authentication',
            'data': data,
        }).subscribe(function (result) {
            console.log(result);
            if (result.success == true) {
                console.log("登陆成功");
                var link = ['learning-map'];
                _this.router.navigate(link);
            }
            else {
                // $('.PwdTxt').text('账号密码不正确');
                // $('.PwdTxt').addClass('showTxt');
                _this.submitButtonDisabled = false;
                _this.toset("账号密码不正确");
                return;
            }
        });
    };
    ActivityFormComponent.prototype.cancel = function () {
        $(".model_div").css('display', 'none');
        $(".model_div_con").css('display', 'none');
    };
    ///* 企业员工可以通过员工号密码登录学习  2019-9-4 end*/
    ActivityFormComponent.prototype.login = function () {
        var _this = this;
        this.phone = this.phone_1;
        this.verification_code = this.verification_code_1;
        if (this.phone == "" || typeof (this.phone) == 'undefined') {
            // this.tip("请填写手机号");
            $('.phoneValidateTxt').text('请填写手机号码');
            $('.phoneValidateTxt').addClass('showValidateTxt');
            return;
        }
        if (!this.checkMobile(this.phone)) {
            $('.phoneValidateTxt').text('请填写正确手机号');
            $('.phoneValidateTxt').addClass('showValidateTxt');
            // this.tip("请填写正确手机号");
            return;
        }
        this.submitButtonDisabled = true;
        if (!this.phone) {
            // this.tip("请填写手机号码");
            $('.phoneValidateTxt').text('请填写手机号码');
            $('.phoneValidateTxt').addClass('showValidateTxt');
            this.submitButtonDisabled = false;
            return false;
        }
        else if (!this.verification_code) {
            // this.tip("请填写手机验证码");
            $('.smsCodeValidateTxt').text('请填写手机验证码');
            $('.smsCodeValidateTxt').addClass('showValidateTxt');
            this.submitButtonDisabled = false;
            return false;
        }
        var data = {
            "registerType": 1,
            "phone": this.phone,
            "verification_code": this.verification_code,
        };
        this.apiService.registerUser(data).subscribe(function (result) {
            console.log(result);
            if (result.code == "Success") {
                console.log("登陆成功");
                var link = ['learning-map'];
                _this.router.navigate(link);
            }
            if (result.code == "Not_Lookup_Company") {
                console.log("您还没有绑定任何账户");
                $("#mengban").fadeIn();
            }
            else if (result.code == "Not_Matched") {
                // this.tip("手机号或验证码不正确");
                $('.smsCodeValidateTxt').text('手机号或验证码不正确');
                $('.smsCodeValidateTxt').addClass('showValidateTxt');
                _this.submitButtonDisabled = false;
                return;
            }
            else if (result.code == "Duplicate_Company") {
                // this.tip(this.name + "已经被注册");
                $('.phoneValidateTxt').text(_this.name + "已经被注册");
                $('.phoneValidateTxt').addClass('showValidateTxt');
                _this.submitButtonDisabled = false;
                return;
            }
            else if (result.code == "Phone_Not_Matched") {
                // this.tip("手机号和接受验证码手机号不一致，请重新发送验证码");
                $('.phoneValidateTxt').text('手机号或验证码不正确');
                $('.phoneValidateTxt').addClass('showValidateTxt');
                _this.submitButtonDisabled = false;
                return;
            }
        });
    };
    ActivityFormComponent.prototype.submitForm = function (isPersonal) {
        var _this = this;
        if (isPersonal) {
            this.phone = this.phone_1;
            this.verification_code = this.verification_code_1;
        }
        else {
            this.phone = this.phone_2;
            this.verification_code = this.verification_code_2;
        }
        if (this.phone == "" || typeof (this.phone) == 'undefined') {
            // this.tip("请填写手机号");
            $('.phoneValidateTxt').text('请填写手机号');
            $('.phoneValidateTxt').addClass('showValidateTxt');
            return;
        }
        if (!this.checkMobile(this.phone)) {
            // this.tip("请填写正确手机号");
            $('.phoneValidateTxt').text('请填写正确手机号');
            $('.phoneValidateTxt').addClass('showValidateTxt');
            return;
        }
        this.submitButtonDisabled = true;
        if (this.registerType == 2) {
            if (!this.name) {
                // this.tip("请填写公司名称");
                $('.companyNameValidateTxt').addClass('showValidateTxt');
                this.submitButtonDisabled = false;
                return false;
            }
            else if (!this.myname) {
                // this.tip("请填写姓名");
                $('.usernameValidateTxt').addClass('showValidateTxt');
                this.submitButtonDisabled = false;
                return false;
            }
            else if (!this.size) {
                // this.tip("请填写公司规模");
                $('.companySizeValidateTxt').addClass('showValidateTxt');
                this.submitButtonDisabled = false;
                return false;
            }
            else if (!this.title) {
                // this.tip("请填写职务");
                $('.companyJobValidateTxt').addClass('showValidateTxt');
                this.submitButtonDisabled = false;
                return false;
            }
        }
        if (!this.phone) {
            // this.tip("请填写手机号码");
            $('.phoneValidateTxt').text('请填写手机号码');
            $('.phoneValidateTxt').addClass('showValidateTxt');
            this.submitButtonDisabled = false;
            return false;
        }
        else if (!this.verification_code) {
            // this.tip("请填写手机验证码");
            $('.phoneValidateTxt').text('请填写手机验证码');
            $('.smsCodeValidateTxt').addClass('showValidateTxt');
            this.submitButtonDisabled = false;
            return false;
        }
        var data = {
            "registerType": this.registerType,
            "phone": this.phone,
            "verification_code": this.verification_code,
            "name": this.name,
            "size": this.size,
            "title": this.title,
            "myname": this.myname,
            "registerCode_2": this.registerCode
        };
        this.apiService.registerUser(data).subscribe(function (result) {
            console.log(typeof (result.code));
            if (result.code == "Success" || result.code == "1" || result.code == "2") {
                window.sessionStorage.setItem('submitType', result.code);
                var link = ['success'];
                _this.router.navigate(link);
            }
            else if (result.code == "Not_Matched") {
                // this.tip("手机号或验证码不正确");
                $('.smsCodeValidateTxt').text('手机号或验证码不正确');
                $('.smsCodeValidateTxt').addClass('showValidateTxt');
                _this.submitButtonDisabled = false;
                return;
            }
            else if (result.code == "Duplicate_Company") {
                // this.tip(this.name + "已经被注册");
                $('.phoneValidateTxt').text(_this.name + "已经被注册");
                $('.phoneValidateTxt').addClass('showValidateTxt');
                _this.submitButtonDisabled = false;
                return;
            }
            else if (result.code == "Phone_Not_Matched") {
                // this.tip("手机号和接受验证码手机号不一致，请重新发送验证码");
                $('.phoneValidateTxt').text('手机号和接受验证码手机号不一致,请重新发送验证码');
                $('.phoneValidateTxt').addClass('showValidateTxt');
                _this.submitButtonDisabled = false;
                return;
            }
            else if (result.code == "Err_RegisterCode") {
                // this.tip("您的识别码有误/无效，请重新输入");
                $('.registerCodeValidateTxt').addClass('showValidateTxt');
                // let interval = setInterval(function () {
                //   $('.registerCodeValidateTxt').removeClass('showRegisterCodeValidateTxt');
                //   clearInterval(interval);
                // }, 2500);
                _this.submitButtonDisabled = false;
                return;
            }
        });
    };
    return ActivityFormComponent;
}());
export { ActivityFormComponent };



// WEBPACK FOOTER //
// ./src/app/activity-form/activity-form.component.ts.pre-build-optimizer.js